module.exports = __webpack_public_path__ + "static/img/bcg_k9.819e8b69.png";